import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PlanningConfiguration } from '../../types/instanceTypes';
import { getPlanningConfiguration, getCertificateSettings } from '../../services/instanceService';

interface InstanceState {
  planningConfiguration: PlanningConfiguration | null;
  certificateEnabled: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: InstanceState = {
  planningConfiguration: null,
  certificateEnabled: false,
  loading: false,
  error: null,
};

export const fetchPlanningConfiguration = createAsyncThunk(
  'instance/fetchPlanningConfiguration',
  async (_, thunkAPI) => {
    try {
      const response = await getPlanningConfiguration();
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message ?? 'Failed to fetch planning config');
    }
  }
);
export const fetchCertificateEnabled = createAsyncThunk(
  'instance/fetchCertificateEnabled',
  async (_, thunkAPI) => {
    try {
      const response = await getCertificateSettings();
      return response.certificateEnabled;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message ?? 'Failed to fetch certificate settings');
    }
  }
);

const instanceSlice = createSlice({
  name: 'instance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanningConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlanningConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.planningConfiguration = action.payload;
      })
      .addCase(fetchPlanningConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchCertificateEnabled.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCertificateEnabled.fulfilled, (state, action) => {
        state.loading = false;
        state.certificateEnabled = action.payload;
      })
      .addCase(fetchCertificateEnabled.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default instanceSlice.reducer;
